// One timeline for the plots, the check lanes and the session video.
//
// t is the trace time in seconds (t_ms / 1000, ms from the first RUNNING frame).
// The video starts at the startMs frame: its pts = t_ms − startMs, the file starts at 0,
// so videoTime = t − startMs / 1000.
// frac is the fraction of the plot area's width (0 is the first trace frame, 1 the last).

// Plot margins: the Y axis on the left, a gap on the right (as for the page's LineChart).
export const PLOT_INSETS = { left: 48, right: 16 };

const clamp01 = (x) => Math.min(1, Math.max(0, x));
const safeSpan = (span) => (span > 0 ? span : 0.001);

/** The width fraction for time t. Not clamped: outside [0, 1] the cursor is hidden. */
export const fracOfT = (t, t0, span) => (t - t0) / safeSpan(span);

/** The time for a width fraction (clamped to the plot). */
export const tOfFrac = (frac, t0, span) => t0 + clamp01(frac) * span;

/** The fraction of the plot area's width under the mouse pointer. */
export function fracFromClientX(clientX, rect, insets = PLOT_INSETS) {
  const width = rect.width - insets.left - insets.right;
  if (!(width > 0)) return 0;
  return clamp01((clientX - rect.left - insets.left) / width);
}

export const videoTimeOfT = (t, startMs) => t - startMs / 1000;
export const tOfVideoTime = (v, startMs) => v + startMs / 1000;

// A video frame is shown from its pts until the next one; the target is just after pts so
// that rounding in the player doesn't show the previous frame.
export const seekTarget = (v) => Math.max(0, v) + 0.0005;

/** The index of the trace row nearest in time to t (s); −1 if there are no frames. */
export function nearestIndex(columns, t) {
  const times = columns.t_ms;
  const n = times.length;
  if (n === 0) return -1;
  const ms = t * 1000;
  let lo = 0;
  let hi = n - 1;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (times[mid] < ms) lo = mid + 1;
    else hi = mid;
  }
  // lo is the first frame not before ms; compare with the previous one (a tie goes to it).
  if (lo > 0 && ms - times[lo - 1] <= times[lo] - ms) lo -= 1;
  return lo;
}

/** The number of the trace frame nearest in time to t (s); null if there are no frames. */
export function nearestFrame(columns, t) {
  const i = nearestIndex(columns, t);
  return i < 0 ? null : columns.frame[i];
}
